import type { BatchProcessDto, FsmSyncMetadataDto } from "@fp/admin-api-client";
import {
  BatchProcessItemOperation,
  FsmSyncMetadataDtoKind,
} from "@fp/admin-api-client";
import { fsmPlatformLabels } from "@/lib/fsm-platform";

export function getFsmSyncMetadata(
  batch: BatchProcessDto,
): FsmSyncMetadataDto | null {
  return batch.metadata?.kind === FsmSyncMetadataDtoKind.fsmSync
    ? batch.metadata
    : null;
}

export function getBatchDisplayName(batch: BatchProcessDto): string {
  const metadata = getFsmSyncMetadata(batch);

  if (!metadata) {
    return batch.name;
  }

  const operationLabel =
    batch.operation === BatchProcessItemOperation.Sync
      ? "sync"
      : "sync preview";

  return `${fsmPlatformLabels[metadata.platform]} ${operationLabel}`;
}